import { render } from "./Tools.vue?vue&type=template&id=51cf845f"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"

import "./Tools.vue?vue&type=style&index=0&id=51cf845f&lang=css"
script.render = render

export default script